import {useMutation, useQuery} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { showHttpErrorToast } from '@common/utils/http/show-http-error-toast';

const endpoint = (id: number) => `market-rates/${id}/send-email`;

interface Response extends BackendResponse {}

interface Payload {
  id: number;
}

export function useSendRateSheet() {

  return useMutation({
    mutationFn: (payload: Payload) => sendRateSheet(payload),
    onError: err => showHttpErrorToast(err),
  });
}

function sendRateSheet({id}: Payload): Promise<Response> {
  return apiClient.post(endpoint(id)).then(r => r.data);
}
